"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = require("react");

var usePlaceService = function usePlaceService() {
  var kakao = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.kakao;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      placeService = _useState2[0],
      setPlaceService = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!kakao) return;
    setPlaceService(new kakao.maps.services.Places());
  }, [kakao]);
  return {
    placeService: placeService
  };
};

var _default = usePlaceService;
exports.default = _default;